<template>
  <div class="asc-add-manual-mx-rec-dialog">
    <asc-dialog
      text="Add a Manual Maintenance Rec"
      :show-dialog="showDialog"
      :on-close="handleClose"
      :width="494"
      :primary-available="isAddMxRecDataValid"
      :on-primary="handleAddMxRecSubmit"
      primary-button-text="Add"
    >
      <template v-if="showDialog">
        <asc-spinner-wrapper :loading="loading">
          <v-container class="pa-0 mt-10">
            <v-row no-gutters>
              <v-col cols="12" class="mb-7">
                <!-- Tier 3 should not come up becaue manual phm is only for tier 4 -->
                <asc-autocomplete-selector
                  id="tail"
                  v-model="tailId"
                  :items="getLookupTierTails('tail')"
                  placeholder="Select a Tail"
                  label="Tail"
                  :on-change="handleSelectorChange"
                  required
                  no-array
                  fixed-position
                ></asc-autocomplete-selector>
              </v-col>
              <v-col cols="12" class="mb-7">
                <asc-autocomplete-selector
                  id="component"
                  v-model="componentId"
                  :items="getUniqueComponents('component')"
                  placeholder="Select a Component"
                  label="Component"
                  :on-change="handleSelectorChange"
                  required
                  no-array
                  fixed-position
                ></asc-autocomplete-selector>
              </v-col>
              <v-col cols="12" class="mb-7">
                <asc-text-field-input
                  v-model="partNumber"
                  label="Part Number"
                  :max-length="partNumberFieldMaxLength"
                  hide-details
                />
              </v-col>
              <v-col cols="12" class="mb-7">
                <asc-autocomplete-selector
                  id="analyticModuleId"
                  v-model="analyticModuleId"
                  :items="getLookupFilteredItems('analyticModule')"
                  placeholder="Select a Analytic"
                  label="Associated Analytic"
                  :on-change="handleSelectorChange"
                  no-array
                  fixed-position
                ></asc-autocomplete-selector>
              </v-col>
              <v-col cols="12" class="mb-7">
                <asc-autocomplete-selector
                  id="source"
                  v-model="sourceId"
                  :items="getLookupItems('source')"
                  placeholder="Select a Issue Source"
                  label="Issue Source"
                  :sort-items="false"
                  no-array
                  fixed-position
                ></asc-autocomplete-selector>
              </v-col>
            </v-row>
          </v-container>
        </asc-spinner-wrapper>
      </template>
    </asc-dialog>
  </div>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscAutocompleteSelector from '@/components/molecules/AscAutocompleteSelector'
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'
import { COLLINS_PHM_TIER_4 } from '@/utilities/appConsts'

import _ from 'lodash'

export default {
  name: 'AscAddManualMxRecDialog',

  components: {
    AscDialog,
    AscSpinnerWrapper,
    AscAutocompleteSelector,
    AscTextFieldInput,
  },

  mixins: [AscDialogMixin],

  props: {
    onManualMxRecAdd: {
      type: Function,
      default: () => {},
    },
    lookups: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      tailId: null,
      partNumber: null,
      componentId: null,
      analyticModuleId: null,
      sourceId: 6,
      partNumberFieldMaxLength: 50,
      mappedComponents: [],
    }
  },
  computed: {
    isAddMxRecDataValid() {
      return (
        this.tailId !== null &&
        this.componentId !== null &&
        this.sourceId !== null
      )
    },
  },
  methods: {
    getLookup(id) {
      return _.find(this.lookups, ['id', id])
    },
    getLookupItems(id) {
      return this.getLookup(id) && this.getLookup(id).items
        ? this.getLookup(id).items
        : []
    },
    getLookupFilteredItems(id) {
      return this.getLookup(id) && this.getLookup(id).filteredItems
        ? this.getLookup(id).filteredItems
        : []
    },
    getLookupTierTails(id) {
      return this.getLookup(id) && this.getLookup(id).items
        ? this.getLookup(id).items.filter(
            item => item['airlineTierTypeId'] === COLLINS_PHM_TIER_4,
          )
        : []
    },
    getUniqueComponents(id) {
      const lookupComponent = _.find(this.lookups, ['id', id])
      const components = lookupComponent.items
      const filteredComponents = lookupComponent.filteredItems
      if (components.length && !this.mappedComponents.length) {
        const duplicateSysName = []
        const duplicates = components.filter((item, index, array) => {
          const c = array.map(item => item.text)
          const i = array.findIndex(
            val => val.text === item.text && val.systemName === item.systemName,
          )
          if (i >= 0 && i !== index) {
            duplicateSysName.push(item)
          }
          return index !== c.indexOf(item.text)
        })
        this.mappedComponents = components.map(function (item) {
          let compName = item.text
          const dupName = Boolean(
            duplicates.find(
              x => x.value !== item.value && x.text === item.text,
            ),
          )
          const dupSysName = Boolean(
            duplicateSysName.find(
              y =>
                y.systemName === item.systemName &&
                y.text === item.text &&
                y.value !== item.value,
            ),
          )
          if (dupName && !dupSysName) {
            compName = item.text + ` (${item.systemName})`
          } else if (dupName && dupSysName) {
            compName = item.text + ` (${item.systemName} - ${item.value})`
          }
          return {
            ...item,
            text: compName,
            value: item.value,
          }
        })
      }

      return this.mappedComponents.length && filteredComponents?.length
        ? this.mappedComponents.filter(item => {
            return Boolean(
              filteredComponents.find(comp => comp.value === item.value),
            )
          })
        : []
    },
    resetLookupsSelected() {
      this.lookups.map(lookup => {
        delete lookup.selectedItem
        delete lookup.filteredItems
        return lookup
      })

      this.componentId = null
    },
    // eslint-disable-next-line no-unused-vars
    handleSelectorChange(id, selection = null, selectedItems = []) {
      if (id === 'tail') this.resetLookupsSelected()

      const lookup = this.getLookup(id)

      if (lookup) {
        if (selectedItems && selectedItems.length) {
          lookup.selectedItem = selectedItems[0]
        } else {
          lookup.filteredItems = []
        }

        if (lookup.parent) {
          const parentLookup = this.getLookup(lookup.parent)

          lookup.filteredItems = _.filter(lookup.items, function (item) {
            if (parentLookup.selectedItem) {
              if (_.isArray(parentLookup.selectedItem[lookup.filterId])) {
                return _.includes(
                  parentLookup.selectedItem[lookup.filterId],
                  item[lookup.filterId],
                )
              } else {
                return (
                  parentLookup.selectedItem[lookup.filterId] ===
                  item[lookup.filterId]
                )
              }
            }

            return false
          })

          if (id === 'system') {
            // Select all unique systems
            lookup.selectedItem = {
              systemId: _.uniq(_.map(lookup.filteredItems, 'systemId')),
            }
          }
        }

        if (lookup.child) {
          this.handleSelectorChange(lookup.child)
        }
      }
    },
    handleAddMxRecSubmit() {
      const data = {
        tailName: this.getLookup('tail').selectedItem.text,
        partNumber: this.partNumber,
        componentId: this.componentId,
        analyticModuleId: this.analyticModuleId,
        sourceId: this.sourceId,
      }

      if (this.onManualMxRecAdd) {
        this.onManualMxRecAdd(data)
      }

      this.resetManualMxRec()
    },
    resetManualMxRec() {
      this.tailId = null
      this.partNumber = null
      this.componentId = null
      this.analyticModuleId = null
      this.sourceId = 6
    },
    handleClose() {
      if (this.onClose && !this.loading) {
        this.resetManualMxRec()
        this.onClose()
      }
    },
  },
}
</script>
<style lang="scss">
.asc-add-manual-mx-rec-dialog {
  .asc-dialog {
    .v-card {
      .asc-dialog-slot {
        overflow-x: hidden;
      }

      .v-divider {
        display: none;
      }

      &__actions {
        .row {
          > div {
            width: 100%;

            .v-btn {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
